import React, { useEffect, useRef } from 'react';
import { format } from "date-fns";
import { useNavigate } from "react-router";

interface BlogItemProps {
	image: React.ReactElement,
	text: string,
	date: any,
	id?: number,
	index?: number,
	setHeight?: any,
	setIndex: (newIndex: number) => void;
	href: string;
}

const BlogItemComponent = (props: BlogItemProps) => {
	const formattedDate = format(new Date(props.date), 'MMM do, yyyy');
	const navigate = useNavigate();
	const blogItemRef = useRef<HTMLDivElement | null>(null);
	const [touchStart, setTouchStart] = React.useState(0);
	const [touchEnd, setTouchEnd] = React.useState(0);
	
	useEffect(() => {
		if (blogItemRef.current && props.index === props.id && props.setHeight) {
			const blogItemHeight = blogItemRef.current.offsetHeight;
			props.setHeight(blogItemHeight);
		}
	}, [props.index]);
	
	function handleTouchStart(e: any) {
		setTouchStart(e.targetTouches[0].clientX);
	}
	
	function handleTouchMove(e: any) {
		setTouchEnd(e.targetTouches[0].clientX);
	}
	
	function handleTouchEnd() {
		if (touchStart - touchEnd > 120 && props.index !== 2) {
			props.setIndex(1);
		}
		
		if (touchStart - touchEnd < -120 && props.index !== 0) {
			props.setIndex(-1);
		}
	}
	
	return (
		<div
			className={`blogItemComponent ${props.index === props.id ? 'active' : ''}`}
			onClick={() => navigate(`/article/${props.href}`)}
			ref={blogItemRef}
			onTouchStart={handleTouchStart}
			onTouchEnd={handleTouchEnd}
			onTouchMove={handleTouchMove}
		>
			{props.image}
			<div className="blogItemComponent_data">
				<span>{props.text}</span>
			</div>
			<div className="blogItemComponent_info">
				{/*<div className="blogItemComponent_info_date">*/}
				{/*	<span>{formattedDate}</span>*/}
				{/*</div>*/}
				<div className="blogItemComponent_info_label">
					<div className="blogItemComponent_info_label_dot"></div>
					<span>WEB 3.0</span>
				</div>
			</div>
		</div>
	);
};

export default BlogItemComponent;